import { Card } from '../card'
import './style.css'

export function OurHospitals({ hospitals }) {
  return (
    <section>
      <h2 className="cards-title">Nossos Hospitais</h2>
      <div className="cards-section">
        <div className="cards-container">
          {hospitals.map((hospital, index) => (
            <div key={index} className="hospital-item">
              <Card
                icon={hospital.icon}
                route={hospital.route}
                image={hospital.image}
                description={hospital.description}
              />
              <h3 className="hospital-name">{hospital.title}</h3>
              <p className="hospital-description">{hospital.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
